import { defineComponent as _defineComponent } from 'vue'
import ArticleCard from './ArticleCard.vue';
import CarouselArrowButton from 'JS/components/carousels/CarouselArrowButton.vue';
import CarouselIndicators from 'JS/dxp/components/shared/CarouselIndicators.vue';
import Icon from 'JS/components/Icon.vue';
import PostSkeleton from './PostSkeleton.vue';
import { BlogCarouselWidgetData } from 'JS/dxp/types/widgets/blog-carousel-widget';
import { BlogPost, BlogTerm } from 'JS/types/Blog';
import { computed, inject, nextTick, onMounted, ref, watch } from 'vue';
import { createListSlider } from 'JS/list-slider';
import { lazyLoadImages } from 'JS/global/images';
import { onWindowResize } from 'JS/utilities/viewport';
import { useListSlider } from 'JS/composables/list-slider';
import { useViewportWidth } from 'JS/composables/breakpoint';



export default /*#__PURE__*/_defineComponent({
  __name: 'NewBlogCarousel',
  props: {
    heading: null,
    data: null,
    viewAllLink: null
  },
  setup(__props: any) {

const props = __props as {
	heading: string;
	data: BlogCarouselWidgetData; // Use when loading with information from back end
	viewAllLink?: string;
}

const BLOG_LINK = "https://www.farmandfleet.com/blog/";



const viewAllLink = computed(() => {
	if (props.viewAllLink) return props.viewAllLink;

	if (!props.data) return;

	let viewLink = BLOG_LINK;

	if (props.data.category) {
 		viewLink = props.data.category.link || viewLink;
 	} else if (props.data.tags.length) {
		if (props.data.tags.length === 1) {
			viewLink = props.data.tags[0].link;
		} else if (props.data.tags.length > 1) {
			// build a query string of tag slugs
			const tagArray = props.data.tags?.map((tag: BlogTerm) => {
				return tag?.slug;
			});

			viewLink = BLOG_LINK + (tagArray?.length ? `?s=&tag=${tagArray.join(',')}` : '');
		}
	}

	return viewLink;
});

const { slider, viewport, previous, next } = useListSlider();

const viewportWidth = useViewportWidth();

onMounted(() => {
	// We need to set up our carousel on load to populate our indicators
	setupCarousel();
});


function setupCarousel() {
	// In order to get accurate values we need to wait until next tick
	nextTick(() => {
		slider.value?.reset();
	});
}

return { __sfc: true,BLOG_LINK, props, viewAllLink, slider, viewport, previous, next, viewportWidth, setupCarousel, ArticleCard, CarouselArrowButton, Icon, PostSkeleton }
}

})